import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const DEFAULTS = {
  whatsappNumber: "+34612523474",
  whatsappDefaultGreeting: "Hola MercaGo, necesito ayuda con...",
  whatsappFloatingEnabled: true,
};

const SettingsContext = createContext({
  ...DEFAULTS,
  refresh: () => {},
  loading: true,
});

export function SettingsProvider({ children }) {
  const [state, setState] = useState({ ...DEFAULTS, loading: true });

  const load = useCallback(() => {
    return api
      .get("/settings/public")
      .then((r) => {
        const d = r.data || {};
        setState({
          whatsappNumber: d.whatsapp_number || DEFAULTS.whatsappNumber,
          whatsappDefaultGreeting:
            d.whatsapp_default_greeting || DEFAULTS.whatsappDefaultGreeting,
          whatsappFloatingEnabled:
            typeof d.whatsapp_floating_enabled === "boolean"
              ? d.whatsapp_floating_enabled
              : DEFAULTS.whatsappFloatingEnabled,
          loading: false,
        });
      })
      .catch(() => setState((s) => ({ ...s, loading: false })));
  }, []);

  useEffect(() => {
    load();
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [load]);

  return (
    <SettingsContext.Provider value={{ ...state, refresh: load }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
